// @flow

import { find, get, isEmpty } from 'lodash';

import getNumFreeMeteredTasks from '../getNumFreeMeteredTasks';

import type { AccountPlan, Interval } from '@zapier/common-utils';

const sortTaskLimitVariants = (plans: Array<AccountPlan>): Array<AccountPlan> =>
  plans.map(plan =>
    plan.task_limit_variants
      ? {
          ...plan,
          // arrange task limit variants from lowest to highest
          task_limit_variants: plan.task_limit_variants.sort(
            (a, b) => a.tasks - b.tasks
          ),
        }
      : plan
  );

export default (
  accountPlans: Array<AccountPlan>,
  currentPlanId: number,
  selectedInterval: ?Interval | string
) => {
  const currentPlan = accountPlans.find(plan => {
    const intervals = get(plan, 'intervals', []);
    const interval =
      find(intervals, { interval: selectedInterval }) || intervals[0];

    return interval.id === currentPlanId;
  });

  const plans = accountPlans.reduce((results, plan) => {
    const tasks = !isEmpty(get(plan, 'metered_pricing_tiers'))
      ? getNumFreeMeteredTasks(plan)
      : get(plan, 'actions');

    const isInPlanGroup = !get(plan, 'off_plan_group', false);

    const index = results.findIndex(p => p.plan_type === plan.plan_type);
    const taskLimitVariant = {
      intervals: plan.intervals,
      name: plan.name,
      tasks,
    };

    // The data that should be at the root level of the plan object (as opposed to in a taskLimitVariant)
    const rootPlan =
      currentPlan && plan.plan_type === currentPlan.plan_type
        ? currentPlan
        : plan;

    if (!isInPlanGroup) {
      results.push({
        ...rootPlan,
        plan_type: undefined, // don't want out-of-plan group plans to get grouped with in-plan group plans
        task_limit_variants: [taskLimitVariant],
      });
    } else if (index === -1) {
      // If this type grouping doesn't already exists in the accumulated array...
      results.push({
        ...rootPlan,
        task_limit_variants: [taskLimitVariant],
      });
    } else {
      results[index].task_limit_variants.push(taskLimitVariant);
    }

    return results;
  }, []);

  return sortTaskLimitVariants(plans);
};
